// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import styled from 'styled-components'
import { signIn, signOut } from './../actions/auth';
import { 
  AXIOS_INSTANCE,
  LOADING
} from './../types/auth';
import type { AuthProps } from './../types/auth';

type Auth = {
  get: string => string,
  axiosInstance: Object,
  login: string,
  loading: boolean
};

type State = {
  auth: Auth,
};

const StyledWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: ${props => props.absolute};
`;

function getDisplayName(WrappedComponent: React.ComponentType<any>): string {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withAuth(WrappedComponent: React.ComponentType<any>, componentIsMap?: boolean): React.ComponentType<any> {
  class WithAuth extends React.Component<AuthProps, State> {
    renderContent(): React.Node {
      return (<WrappedComponent {...this.props} />);
    }

    render(): React.Node {
      if (componentIsMap) {
        return (
          <StyledWrapper absolute='absolute'>
            {this.renderContent()}
          </StyledWrapper>
        );
      }

      return (
        <StyledWrapper>
          {this.renderContent()}
        </StyledWrapper>
      );
    }
  }

  const mapStateToProps = state => ({
    [LOADING]: state.auth.get(LOADING),
    [AXIOS_INSTANCE]: state.auth.get(AXIOS_INSTANCE)
  });

  const mapDispatchToProps = dispatch => Redux.bindActionCreators({
    signIn,
    signOut,
  }, dispatch);

  WithAuth.displayName = `WithAuth(${getDisplayName(WrappedComponent)})`;

  return connect(mapStateToProps, mapDispatchToProps)(WithAuth);
};

export default withAuth;



// WEBPACK FOOTER //
// ./src/hocs/auth.jsx